export default __webpack_public_path__ + "static/centrik_logo-f220d1ff2e36435f0296ee200dd4fb02.png";